import React from "react";
import { Link } from "react-router-dom";
import "./Home.css";
import {
  IconFrete,
  IconLista,
  IconProposta,
  IconSeta,
} from "../../Shared/Icons/Icons";

const ATALHOS = [
  {
    to: "/Propostas",
    titulo: "Propostas",
    descricao: "Acompanhe as propostas capturadas e atualize o status de cada uma.",
    Icone: IconLista,
  },
  {
    to: "/Proposta-Comercial",
    titulo: "Nova proposta",
    descricao: "Gere o PDF da proposta comercial a partir do link do Tiny.",
    Icone: IconProposta,
  },
  {
    to: "/Cotação-Frete",
    titulo: "Cotação de frete",
    descricao: "Calcule PAC e SEDEX pelo SKU dos produtos e copie a mensagem.",
    Icone: IconFrete,
  },
];

const Home = () => {
  return (
    <div className="page">
      <div className="page-header">
        <h1 className="page-title">Início</h1>
        <p className="page-subtitle">
          Escolha uma das ferramentas comerciais da BTK para começar.
        </p>
      </div>

      <ul className="home-cards">
        {ATALHOS.map(({ to, titulo, descricao, Icone }) => (
          <li key={to}>
            <Link to={to} className="card home-card">
              <span className="home-card-icon">
                <Icone />
              </span>
              <h2 className="home-card-title">{titulo}</h2>
              <p className="home-card-text">{descricao}</p>
              <span className="home-card-cta" aria-hidden="true">
                Acessar <IconSeta size={16} />
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Home;
